// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"dcb2148a","213":"f03de26f","453":"5d7f33fb"}[chunkId] + ".chunk.js";
};